// Flattens the conversation state (whose FK fields are nested objects, as
// returned by GET /api/conversations/:id) into the raw-id shape the backend
// PUT endpoint expects, merging in whatever fields are being changed.
//
// Always sending every field (not just the changed one) works around a
// backend bug where PUT overwrites fields omitted from the request body.

function idOf(value) {
    if (value === null || value === undefined) return null;
    if (typeof value === "object") return value.id;
    return value;
}

export function buildConversationUpdatePayload(conversation, changes = {}) {
    const merged = { ...conversation, ...changes };

    return {
        id: merged.id,
        name: merged.name,
        description: merged.description,
        hashCode: merged.hashCode,
        price: merged.price,
        isPublic: merged.isPublic,
        typeId: idOf(merged.typeId),
        level: idOf(merged.level),
        estimationFunction: idOf(merged.estimationFunction),
        stageTypeId: idOf(merged.stageTypeId),
        isPresent: idOf(merged.isPresent),
    };
}
